// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZIyz","left":"styles_left__34d4b","desktopActions":"styles_desktopActions__lNnN2","title":"styles_title__3jSHU"};